import React, { useEffect, useState } from "react";
import { getPrivacyPolicy, getSeoByUrl } from "../api/api";

const PrivacyPolicy = () => {
  const [policy, setPolicy] = useState("");
  const [seoData, setSeoData] = useState(null);
  const [loading, setLoading] = useState(true);

  // Fetch SEO data
  useEffect(() => {
    const fetchSeoData = async () => {
      try {
        const response = await getSeoByUrl("privacy-policy");
        if (response.success && response.data) {
          setSeoData(response.data);
          updateMetaTags(response.data);
        }
      } catch (error) {
        console.error("Error fetching SEO data:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchSeoData();
  }, []);

  // Fetch policy content
  useEffect(() => {
    const fetchPolicy = async () => {
      const response = await getPrivacyPolicy();
      if (response.status && response.data && response.data.privacy_policy) {
        setPolicy(response.data.privacy_policy);
      } else {
        setPolicy("<p>Failed to load privacy policy.</p>");
      }
    };
    fetchPolicy();
  }, []);

  const updateMetaTags = (data) => {
    if (data.metaTitle) document.title = data.metaTitle;
    
    let metaDesc = document.querySelector('meta[name="description"]');
    if (!metaDesc) {
      metaDesc = document.createElement('meta');
      metaDesc.setAttribute('name', 'description');
      document.head.appendChild(metaDesc);
    }
    if (data.metaDescription) metaDesc.setAttribute('content', data.metaDescription);
    
    let robotsMeta = document.querySelector('meta[name="robots"]');
    if (!robotsMeta) {
      robotsMeta = document.createElement('meta');
      robotsMeta.setAttribute('name', 'robots');
      document.head.appendChild(robotsMeta);
    }
    if (data.robotsTxt) robotsMeta.setAttribute('content', data.robotsTxt);
    
    let canonicalLink = document.querySelector('link[rel="canonical"]');
    if (!canonicalLink) {
      canonicalLink = document.createElement('link');
      canonicalLink.setAttribute('rel', 'canonical');
      document.head.appendChild(canonicalLink);
    }
    if (data.canonicalUrl) canonicalLink.setAttribute('href', data.canonicalUrl);
 
  };

  return (
    <div className="custom-padding xl-screen-padding pt-80 pb-80 font-lato">
      <div className="policy-content" dangerouslySetInnerHTML={{ __html: policy }} />
    </div>
  );
};

export default PrivacyPolicy;